import { IEnrollmentTermItem } from '@/entities/Enrollment';
import { COURSE_TYPE } from '@/shared/constants/courseData';
import { getProgressPercent } from '@/shared/lib/utils/getProgressPercent';

export const enrollmentDto = (data: IEnrollmentTermItem) => {
  const typeCourse = COURSE_TYPE[data.course.type] || data.course.type;
  const termNumber = data.term.number || null;
  const groupNumber = data.groupNumber || null;

  const descriptionParts: string[] = [];
  if (data.course.type !== 'short' && termNumber) {
    descriptionParts.push(`Term ${termNumber}`);
  }
  if (groupNumber) {
    descriptionParts.push(`Group ${groupNumber}`);
  }
  const description = descriptionParts.length > 0 ? descriptionParts.join(', ') : undefined;

  return {
    typeCourse,
    title: `${data.course.title} ${data.intake.title}`,
    description,
    href: `/enrollments/${data.enrollmentId}/terms/${data.term.intakeTermId}`,
    modules: {
      completed: data.finishedModules,
      total: data.totalModules,
    },
    progress: getProgressPercent(data.finishedModules, data.totalModules),
  };
};
